import { render, staticRenderFns } from "./CheckboxesInputValidation.vue?vue&type=template&id=e84e8222&"
import script from "./CheckboxesInputValidation.vue?vue&type=script&lang=js&"
export * from "./CheckboxesInputValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports